import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const ModalGestionCorreo = ({
    isOpen,
    registro,
    onSave,
    onClose,
    usuarioId,
    perfilId,
    tiposSolicitud = [],
    estadosGestion = [],
    usuariosCatalog = [],
    perfilesCatalog = []
}) => {
    const getInitialState = () => ({
        usuario_id_solicitante: usuarioId,
        tipo_solicitud: '',
        usuario_id_correo: '',
        perfil_id_correo: '',
        correo_corporativo: '',
        fecha_registro: new Date().toISOString().split('T')[0],
        fecha_atencion: '',
        estado: 1
    });

    const [formData, setFormData] = useState(getInitialState());

    useEffect(() => {
        if (isOpen) {
            if (registro) {
                setFormData({
                    gestion_correo_id: registro.gestion_correo_id,
                    usuario_id_solicitante: registro.usuario_id_solicitante,
                    tipo_solicitud: registro.tipo_solicitud,
                    usuario_id_correo: registro.usuario_id_correo,
                    perfil_id_correo: registro.perfil_id_correo || '',
                    correo_corporativo: registro.correo_corporativo,
                    fecha_registro: registro.fecha_registro?.split('T')[0] || '',
                    fecha_atencion: registro.fecha_atencion?.split('T')[0] || '',
                    estado: registro.estado
                });
            } else {
                setFormData(getInitialState());
            }
        }
    }, [registro, isOpen, usuarioId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!formData.tipo_solicitud || !formData.usuario_id_correo || !formData.correo_corporativo) {
            alert('Por favor, complete todos los campos obligatorios.');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.correo_corporativo)) {
            alert('Por favor, ingrese un correo electrónico válido.');
            return;
        }

        const dataToSave = {
            ...formData,
            usuario_id_solicitante: parseInt(formData.usuario_id_solicitante),
            tipo_solicitud: parseInt(formData.tipo_solicitud),
            usuario_id_correo: parseInt(formData.usuario_id_correo),
            perfil_id_correo: formData.perfil_id_correo ? parseInt(formData.perfil_id_correo) : null,
            estado: parseInt(formData.estado)
        };

        if (perfilId == 8 && registro) {
            dataToSave.fecha_atencion = new Date().toISOString().split('T')[0];
        }

        try {
            await onSave(dataToSave);
            onClose(true);
        } catch (error) {
            console.error("Error al guardar:", error);
        }
    };

    const isViewOnly = ![8, 5, 22, 12, 24, 25, 26].includes(Number(perfilId));
    const showDates = ![5, 22].includes(Number(perfilId));
    const canChangeEstado = Number(perfilId) === 8 && registro;

    const allowedPerfilIds = perfilesCatalog.filter(p => p.area_id == 3).map(p => p.perfil_id);
    const usersInSystems = usuariosCatalog.filter(u => allowedPerfilIds.includes(String(u.perfil_id)) || allowedPerfilIds.includes(Number(u.perfil_id)));

    const filteredUsuarios = formData.perfil_id_correo
        ? usersInSystems.filter(u => u.perfil_id == formData.perfil_id_correo)
        : usersInSystems;

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{registro ? 'EDITAR GESTIÓN DE CORREO' : 'NUEVA GESTIÓN DE CORREO'}</h1>
                    <Button className="close-btn" onClick={() => onClose()}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={(e) => e.preventDefault()}>

                        {showDates && (
                            <FormGroup>
                                <Label>Fecha Registro:</Label>
                                <Input
                                    className="form-control"
                                    type="date"
                                    name="fecha_registro"
                                    value={formData.fecha_registro}
                                    onChange={handleChange}
                                    disabled={perfilId != 8}
                                />
                            </FormGroup>
                        )}

                        <FormGroup>
                            <Label>Tipo de Solicitud: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="tipo_solicitud"
                                value={formData.tipo_solicitud}
                                onChange={handleChange}
                                disabled={isViewOnly}
                            >
                                <option value="">Seleccione...</option>
                                {tiposSolicitud.map(t => (
                                    <option key={t.tipo_id} value={t.tipo_id}>{t.descripcion}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Cargo:</Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="perfil_id_correo"
                                value={formData.perfil_id_correo}
                                onChange={(e) => {
                                    handleChange(e);
                                    setFormData(prev => ({ ...prev, usuario_id_correo: '', correo_corporativo: '' }));
                                }}
                                disabled={isViewOnly}
                            >
                                <option value="">Seleccione...</option>
                                {perfilesCatalog.filter(p => p.area_id == 3).map(p => (
                                    <option key={p.perfil_id} value={p.perfil_id}>{p.descripcion}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Colaborador: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="usuario_id_correo"
                                value={formData.usuario_id_correo}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const selectedUser = usuariosCatalog.find(u => u.usuario_id == value);
                                    setFormData(prev => ({
                                        ...prev,
                                        usuario_id_correo: value,
                                        correo_corporativo: selectedUser?.correo_corporativo || prev.correo_corporativo
                                    }));
                                }}
                                disabled={isViewOnly}
                            >
                                <option value="">Seleccione...</option>
                                {filteredUsuarios.map(u => (
                                    <option key={u.usuario_id} value={u.usuario_id}>{u.nombre_completo_usuario}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Correo: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="email"
                                name="correo_corporativo"
                                value={formData.correo_corporativo}
                                onChange={handleChange}
                                placeholder="Ingrese el usuario del correo"
                                disabled={isViewOnly}
                            />
                        </FormGroup>

                        {showDates && (
                            <FormGroup>
                                <Label>Fecha Atención:</Label>
                                <Input
                                    className="form-control"
                                    type="date"
                                    name="fecha_atencion"
                                    value={formData.fecha_atencion}
                                    onChange={handleChange}
                                    disabled={perfilId != 8}
                                />
                            </FormGroup>
                        )}

                        {(registro || canChangeEstado) && (
                            <FormGroup>
                                <Label>Estado:</Label>
                                <Input
                                    className="form-control"
                                    type="select"
                                    name="estado"
                                    value={formData.estado}
                                    onChange={handleChange}
                                    disabled={!canChangeEstado}
                                >
                                    {estadosGestion.map(e => (
                                        <option key={e.tipo_id} value={e.tipo_id}>{e.descripcion}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                        )}

                        {!isViewOnly && (
                            <FormGroup>
                                <div className="button-container">
                                    <Button
                                        className="button-custom"
                                        onClick={async () => {
                                            if (window.confirm('¿Está seguro de guardar este registro?')) {
                                                await handleSubmit();
                                            }
                                        }}
                                    >
                                        {registro ? 'ACTUALIZAR' : 'REGISTRAR'}
                                    </Button>
                                </div>
                            </FormGroup>
                        )}

                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalGestionCorreo;
